<p class="eoi"><ng-content></ng-content></p>
